import React, { useState, useEffect } from 'react';
import { Package, Plus, Search } from 'lucide-react';
import { format } from 'date-fns';
import { it } from 'date-fns/locale';
import { Link } from 'react-router-dom';
import AssetModal from '../components/AssetModal';

const API_URL = process.env.REACT_APP_BACKEND_URL;

function Assets() {
  const [assets, setAssets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [filterType, setFilterType] = useState('');
  
  useEffect(() => {
    fetchAssets();
  }, [filterType]);
  
  const fetchAssets = async () => {
    try {
      setLoading(true);
      const url = filterType
        ? `${API_URL}/api/assets?tipo=${filterType}`
        : `${API_URL}/api/assets`;
      
      const res = await fetch(url);
      const data = await res.json();
      setAssets(data);
      setLoading(false);
    } catch (err) {
      console.error('Error fetching assets:', err);
      setLoading(false);
    }
  };
  
  const handleModalClose = (shouldRefresh) => {
    setShowModal(false);
    if (shouldRefresh) {
      fetchAssets();
    }
  };
  
  if (loading && assets.length === 0) {
    return (
      <div className="loading" data-testid="loading">
        <p>Caricamento asset...</p>
      </div>
    );
  }
  
  return (
    <div data-testid="assets-page">
      <div className="page-header">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="page-title">Asset</h1>
            <p className="page-description">
              Gestisci mezzi e attrezzature aziendali
            </p>
          </div>
          <button 
            className="btn btn-primary"
            onClick={() => setShowModal(true)}
            data-testid="create-asset-button"
          >
            <Plus size={20} />
            Nuovo Asset
          </button>
        </div>
      </div>
      
      {/* Filters */}
      <div className="mb-6 flex gap-4">
        <div className="flex gap-2">
          <button
            className={`btn ${filterType === '' ? 'btn-primary' : 'btn-secondary'}`}
            onClick={() => setFilterType('')}
            data-testid="filter-all"
          >
            Tutti
          </button>
          <button
            className={`btn ${filterType === 'mezzo' ? 'btn-primary' : 'btn-secondary'}`}
            onClick={() => setFilterType('mezzo')}
            data-testid="filter-mezzo"
          >
            Mezzi
          </button>
          <button
            className={`btn ${filterType === 'attrezzatura' ? 'btn-primary' : 'btn-secondary'}`}
            onClick={() => setFilterType('attrezzatura')}
            data-testid="filter-attrezzatura"
          >
            Attrezzature
          </button>
        </div>
      </div>
      
      {/* Assets Table */}
      {assets.length === 0 ? (
        <div className="empty-state">
          <Package className="empty-state-icon" />
          <p>Nessun asset trovato</p>
          <button className="btn btn-primary mt-4" onClick={() => setShowModal(true)}>
            <Plus size={20} />
            Aggiungi Primo Asset
          </button>
        </div>
      ) : (
        <div className="card">
          <div className="table-container">
            <table data-testid="assets-table">
              <thead>
                <tr>
                  <th>Tipo</th>
                  <th>Nome</th>
                  <th>Identificativo</th>
                  <th>Marca/Modello</th>
                  <th>Assegnato a</th>
                  <th>Stato</th>
                  <th>Azioni</th>
                </tr>
              </thead>
              <tbody>
                {assets.map((asset) => (
                  <tr key={asset._id} data-testid="asset-row">
                    <td>
                      <span className="badge badge-secondary">{asset.tipo}</span>
                    </td>
                    <td className="font-medium">{asset.nome}</td>
                    <td className="font-mono text-sm">
                      {asset.targa || asset.matricola || '-'}
                    </td>
                    <td>
                      {asset.marca || asset.modello 
                        ? `${asset.marca || ''} ${asset.modello || ''}`.trim()
                        : '-'
                      }
                    </td>
                    <td>
                      {asset.assegnato_a ? (
                        <Link 
                          to={`/employees/${asset.assegnato_a}`}
                          className="text-primary hover:underline"
                        >
                          {asset.employee_nome} {asset.employee_cognome}
                        </Link>
                      ) : (
                        <span className="text-muted-foreground">Non assegnato</span>
                      )}
                    </td>
                    <td>
                      <span className="badge badge-ok">{asset.stato}</span>
                    </td>
                    <td>
                      <Link 
                        to={`/assets/${asset._id}`} 
                        className="btn btn-secondary btn-sm" 
                        data-testid="view-asset"
                      >
                        Dettagli
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
      
      {showModal && (
        <AssetModal onClose={handleModalClose} />
      )}
    </div>
  );
}

export default Assets;
